export function readSiteAndPageNumber(locationPathname: string) {
  const strNumber = locationPathname.split('/').pop();
  const n = parseInt(strNumber || '', 10) || 0;
  const siteNo = Math.floor(n / 1000);
  const pageNo = n % 1000;
  return {
    siteNo,
    pageNo,
  };
}
